import { useState } from "react";
import { Box, Button } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import SearchBar from "../../components/SearchBar";
import { useNavigate } from "react-router-dom";

const SubadminListTopbar = () => {

  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <Box className="search_box">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
          </Box>
        </div>
        <div className="right_s">
          <Button className="btn btn_primary" onClick={() => navigate("/manage-subadmin/roles")}>Roles</Button>
          <Button className="btn btn_primary" onClick={() => navigate("/manage-subadmin/add")}><AddIcon /> Add Sub-Admin</Button>
        </div>
      </div>
    </>
  );
};

export default SubadminListTopbar;
